<template>
  <SummarySection title="Conseil et formule" @edit="$emit('edit')">
    <dl class="mt-2 grid grid-cols-1 gap-x-3 gap-y-1.5 sm:grid-cols-2">
      <div v-if="advisoryUsageLabel">
        <dt class="text-xs font-medium text-gray-500">Type d'usage</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ advisoryUsageLabel }}</dd>
      </div>
      <div v-if="advisoryRisksLabels.length">
        <dt class="text-xs font-medium text-gray-500">Risques à couvrir</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ advisoryRisksLabels.join(", ") }}</dd>
      </div>
      <div v-if="advisoryOfferLabel">
        <dt class="text-xs font-medium text-gray-500">Type d'offre</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ advisoryOfferLabel }}</dd>
      </div>
      <div v-if="advisoryElectronicDevicesValueLabel">
        <dt class="text-xs font-medium text-gray-500">Valeur des appareils électroniques</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ advisoryElectronicDevicesValueLabel }}</dd>
      </div>
      <div v-if="advisoryExistingInsuranceLabel">
        <dt class="text-xs font-medium text-gray-500">Cumul d'assurance</dt>
        <dd class="mt-0.5 text-sm text-gray-900">
          <template v-if="advisoryExistingInsuranceLabel">{{ advisoryExistingInsuranceLabel }}</template>
          <template v-if="advisoryExistingInsuranceReasonLabel">- {{ advisoryExistingInsuranceReasonLabel }}</template>
        </dd>
      </div>
    </dl>
  </SummarySection>
</template>

<script>
import SummarySection from "./SummarySection.vue";

export default {
  components: { SummarySection },
  emits: ["edit"],
  props: {
    advisoryAnswer: {
      type: Object,
      required: true,
    },
  },

  computed: {
    advisoryUsageLabel() {
      const u = this.advisoryAnswer?.usageType;
      return u ? this.$t(`advisory.usageType.${u}`) : "";
    },

    advisoryRisksLabels() {
      const risks = this.advisoryAnswer?.risks || [];
      return risks.map((r) => this.$t(`advisory.risks.${r}`)).filter(Boolean);
    },

    advisoryOfferLabel() {
      const o = this.advisoryAnswer?.offerType;
      return o ? this.$t(`advisory.offerType.${o}`) : "";
    },

    advisoryExistingInsuranceLabel() {
      const v = this.advisoryAnswer?.hasExistingInsurance;
      return v != null ? this.$t(`advisory.hasExistingInsurance.${v}`) : "";
    },

    advisoryExistingInsuranceReasonLabel() {
      const r = this.advisoryAnswer?.existingInsuranceReason;
      if (!r) return "";
      if (r === "other") {
        const otherText = (this.advisoryAnswer?.existingInsuranceReasonOtherText || "").trim();
        return otherText || this.$t("advisory.existingInsuranceReason.other");
      }
      return this.$t(`advisory.existingInsuranceReason.${r}`);
    },

    advisoryElectronicDevicesValueLabel() {
      const v = this.advisoryAnswer?.electronicDevicesValue;
      return v ? this.$t(`advisory.electronicDevicesValue.${v}`) : "";
    },
  },
};
</script>
